import { createElement } from "react";
import React from "react";
import { comparePrimitives, equals, createObj } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { SkeletonItem, Skeleton, Title3, tokens, Caption1, Subtitle2 } from "@fluentui/react-components";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { map as map_1, ofArray } from "../fable_modules/fable-library-js.4.29.0/List.js";
import { useCtx } from "../Context.jsx";
import { ScreenSize, useFeliz_React__React_useResponsive_Static_Z434A9929 } from "../fable_modules/Feliz.UseMediaQuery.1.5.0/UseMediaQuery.fs.js";
import { useEffectOnce } from "../fable_modules/Feliz.2.9.0/Internal.fs.js";
import { startAsPromise } from "../fable_modules/fable-library-js.4.29.0/Async.js";
import { Track, toastServerError, Task } from "../ApiClient.jsx";
import { errorToast } from "../Toasts.jsx";
import { Role } from "../Shared/SharedModels.jsx";
import { FSharpSet__Contains, ofArray as ofArray_1 } from "../fable_modules/fable-library-js.4.29.0/Set.js";
import { append as append_1, sortBy, map } from "../fable_modules/fable-library-js.4.29.0/Array.js";
import { empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.29.0/Seq.js";
import { CreateTrackDialog } from "./CreateTrack.jsx";
import { reactApi as reactApi_1 } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { rangeDouble } from "../fable_modules/fable-library-js.4.29.0/Range.js";
import { General, Enrolled } from "./TrackCard.jsx";

function sectionTitle(title, subtitle) {
    let elems, el, el_2;
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 2 + "px ",
    }], (elems = [(el = Subtitle2, createElement(el, {
        children: title,
    })), (el_2 = Caption1, createElement(el_2, {
        style: {
            color: tokens.colorNeutralForeground3,
        },
        children: subtitle,
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

export function ListTracks() {
    let elems_8;
    const patternInput = useCtx();
    const setCtx = patternInput[1];
    const ctx = patternInput[0];
    const patternInput_1 = reactApi.useState([]);
    const setAllTracks = patternInput_1[1];
    const allTracks = patternInput_1[0];
    const patternInput_2 = reactApi.useState([]);
    const setEnrolledTracks = patternInput_2[1];
    const enrolledTracks = patternInput_2[0];
    const patternInput_3 = reactApi.useState([]);
    const patternInput_4 = reactApi.useState(true);
    const screenSize = useFeliz_React__React_useResponsive_Static_Z434A9929();
    const isMobile = equals(screenSize, new ScreenSize(0, [])) ? true : equals(screenSize, new ScreenSize(1, []));
    useEffectOnce(() => {
        let pr_1;
        const pr = startAsPromise(Task.GetMyCompleted());
        pr_1 = (pr.then((res) => {
            if (res.tag === 1) {
                errorToast(setCtx, "getMyTasksError", "Noe gikk galt", "Kunne ikke hente mine gjennomførte oppgaver", undefined);
            }
            else {
                patternInput_3[1](res.fields[0]);
            }
        }));
        void (pr_1.catch((ex) => {
            toastServerError(setCtx, ex);
        }));
        let pr_3;
        const pr_2 = startAsPromise(Track.GetMy());
        pr_3 = (pr_2.then((res_1) => {
            if (res_1.tag === 1) {
                setEnrolledTracks([]);
            }
            else {
                setEnrolledTracks(res_1.fields[0]);
            }
        }));
        void (pr_3.catch((ex_1) => {
            toastServerError(setCtx, ex_1);
        }));
        let pr_5;
        const pr_4 = startAsPromise(equals(ctx.User.Role, new Role(1, [])) ? Track.GetAll() : Track.GetAllEnabled());
        pr_5 = (pr_4.then((res_2) => {
            if (res_2.tag === 1) {
                errorToast(setCtx, "getTracksError", "Kunne ikke hente læringsløp", "Noe gikk galt", undefined);
            }
            else {
                setAllTracks(res_2.fields[0]);
            }
            patternInput_4[1](false);
            return res_2;
        }));
        void (pr_5.catch((ex_2) => {
            toastServerError(setCtx, ex_2);
        }));
    });
    const enrolledIds = ofArray_1(map((et) => et.Track.Id, enrolledTracks, Int32Array), {
        Compare: comparePrimitives,
    });
    const availableTracks = sortBy((_arg_1) => _arg_1.Name, allTracks.filter((t_2) => !FSharpSet__Contains(enrolledIds, t_2.Id)), {
        Compare: comparePrimitives,
    });
    const sortedEnrolled = sortBy((et_1) => et_1.Track.Name, enrolledTracks, {
        Compare: comparePrimitives,
    });
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        gap: 25 + "px ",
    }], (elems_8 = toList(delay(() => {
        let elems_1;
        return append(singleton(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
        }], (elems_1 = toList(delay(() => {
            let elems, el, el_2;
            return append(singleton(createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
            }], (elems = [(el = Title3, createElement(el, {
                children: "Læringsløp",
            })), (el_2 = Caption1, createElement(el_2, {
                style: {
                    color: tokens.colorNeutralForeground3,
                },
                children: "Alle læringsløp",
            }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => (equals(ctx.User.Role, new Role(1, [])) ? singleton(createElement(CreateTrackDialog, {
                callback: (newTrack) => {
                    setAllTracks(append_1([newTrack], allTracks));
                },
            })) : empty())));
        })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
            let elems_3, elems_5, elems_4;
            return patternInput_4[0] ? singleton(createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
                flexGrow: 1,
                gap: 15 + "px ",
            }], (elems_3 = map_1((_arg_2) => {
                let elems_2, el_4;
                const el_6 = Skeleton;
                return createElement(el_6, createObj(ofArray([["style", {
                    width: 100 + "%",
                }], (elems_2 = [(el_4 = SkeletonItem, createElement(el_4, {
                    size: 128,
                    shape: "rectangle",
                    animation: "wave",
                }))], ["children", reactApi_1.Children.toArray(Array.from(elems_2))])])));
            }, toList(rangeDouble(1, 1, 6))), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))) : append((sortedEnrolled.length > 0) ? singleton(createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
                gap: 12 + "px ",
            }], (elems_5 = [sectionTitle("Mine læringsløp", "Læringsløp du er påmeldt"), createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
                gap: 14 + "px ",
            }], (elems_4 = ofArray(map((et_2) => createElement(Enrolled, {
                isMobile: isMobile,
                userCompletedTasks: patternInput_3[0],
                et: et_2,
            }), sortedEnrolled)), ["children", reactApi.Children.toArray(Array.from(elems_4))])])))], ["children", reactApi.Children.toArray(Array.from(elems_5))])])))) : empty(), delay(() => {
                let elems_7, elems_6;
                return (availableTracks.length > 0) ? singleton(createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    flexDirection: "column",
                    gap: 12 + "px ",
                }], (elems_7 = [sectionTitle("Tilgjengelige læringsløp", "Læringsløp du ikke er påmeldt"), createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    flexDirection: "column",
                    gap: 14 + "px ",
                }], (elems_6 = ofArray(map((t_3) => createElement(General, {
                    isMobile: isMobile,
                    track: t_3,
                }), availableTracks)), ["children", reactApi.Children.toArray(Array.from(elems_6))])])))], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))) : empty();
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_8))])])));
}

//# sourceMappingURL=ListTracks.jsx.map
